import { Fragment, useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  useTheme,
  TableBody,
  TableCell,
  TableRow,
  Radio,
  RadioGroup,
  FormControlLabel,
  Table,
} from '@mui/material';

import MuiTable from 'components/MuiTable';
import { IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';
import useTableForm from './components/useTableForm';
import MuiRadioGroup from './components/MuiRadioGroup';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
}

const STarTContents = (props: Props) => {
  const { palette } = useTheme();
  const { radioGroup, sumValues } = useTableForm(props);
  const { disabled, getValues, setValue } = props;

  const columns = [
    {
      fieldId: 'title',
      label: '',
    },
    {
      fieldId: '0',
      label: '',
      sx: { width: '200px' },
    },
    {
      fieldId: '1',
      label: '',
      sx: { width: '200px' },
    },
    // {
    //   fieldId: '2',
    //   label: '',
    //   sx: { width: '200px' },
    // },
    // {
    //   fieldId: '3',
    //   label: '',
    //   sx: { width: '200px' },
    // },
    // {
    //   fieldId: '4',
    //   label: '',
    //   sx: { width: '200px' },
    // },
  ];

  const rows = [
    {
      id: 'sb01',
      title: '1. 在过去两周内，我的背痛曾经扩散到腿部。',
      ...radioGroup({
        key: 'sb01',
        options: [0, 1],
        i18nKey: 'STARTSCREENING.SCORE',
        width: '150px',
        sx: { whiteSpace: 'nowrap' },
      }),
    },
    {
      id: 'sb02',
      title: '2. 在过去两周内，我曾有过肩部或颈部的疼痛。',
      ...radioGroup({
        key: 'sb02',
        options: [0, 1],
        i18nKey: 'STARTSCREENING.SCORE',
        sx: { whiteSpace: 'nowrap' },
        width: '150px',
      }),
    },
    {
      id: 'sb03',
      title: '3. 在过去两周内，由于背痛我只能走很短的距离。',
      ...radioGroup({
        key: 'sb03',
        options: [0, 1],
        i18nKey: 'STARTSCREENING.SCORE',
        sx: { whiteSpace: 'nowrap' },
        width: '150px',
      }),
    },
    {
      id: 'sb04',
      title: '4. 在过去两周内，我因为背痛穿衣比平时慢。',
      ...radioGroup({
        key: 'sb04',
        options: [0, 1],
        i18nKey: 'STARTSCREENING.SCORE',
        sx: { whiteSpace: 'nowrap' },
        width: '150px',
      }),
    },
    {
      id: 'sb05',
      title: '5. 对于像我这样的病情，进行身体活动其实是不安全的。',
      ...radioGroup({
        key: 'sb05',
        options: [0, 1],
        i18nKey: 'STARTSCREENING.SCORE',
        sx: { whiteSpace: 'nowrap' },
        width: '150px',
      }),
    },
    {
      id: 'sb06',
      title: '6. 烦人的想法经常在我脑海中盘旋。',
      ...radioGroup({
        key: 'sb06',
        options: [0, 1],
        i18nKey: 'STARTSCREENING.SCORE',
        sx: { whiteSpace: 'nowrap' },
        width: '150px',
      }),
    },
    {
      id: 'sb07',
      title: '7. 我觉得我的背痛非常严重，而且永远不会好转。',
      ...radioGroup({
        key: 'sb07',
        options: [0, 1],
        i18nKey: 'STARTSCREENING.SCORE',
        sx: { whiteSpace: 'nowrap' },
        width: '150px',
      }),
    },
    {
      id: 'sb08',
      title: '8. 总的来说，我已经无法像以前那样享受生活中的一切。',
      ...radioGroup({
        key: 'sb08',
        options: [0, 1],
        i18nKey: 'STARTSCREENING.SCORE',
        sx: { whiteSpace: 'nowrap' },
        width: '150px',
      }),
    },
  ];
  const [nine, setNine] = useState(getValues('sb09'));
  // console.log('????', nine);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    if (Number(e.target.value) === 3) {
      return setNine('1'), setValue('sb09', '3');
    } else if (Number(e.target.value) === 4) {
      return setNine('1'), setValue('sb09', '4');
    } else if (Number(e.target.value) === 2) {
      return setNine('0'), setValue('sb09', '2');
    } else if (Number(e.target.value) === 1) {
      return setNine('0'), setValue('sb09', '1');
    } else {
      return setNine('0'), setValue('sb09', '0');
    }
  };
  // console.log('겟벨류09', getValues('sb09'));

  const watchSumValues = () => {
    if (Number(nine) > 0) {
      const values = rows.map(({ id }) => {
        if (props.watch(`${id}`) === undefined) {
          return 0;
        } else {
          return Number(props.watch(`${id}`));
        }
      });
      return sumValues(values) + 1;
    } else {
      const values = rows.map(({ id }) => {
        if (props.watch(`${id}`) === undefined) {
          return 0;
        } else {
          return Number(props.watch(`${id}`));
        }
      });
      // console.log('합?', values);
      return sumValues(values);
    }
  };

  const subSumValues = () => {
    const values1 =
      props.watch('sb05') === undefined ? 0 : Number(props.watch('sb05'));
    const values2 =
      props.watch('sb06') === undefined ? 0 : Number(props.watch('sb06'));
    const values3 =
      props.watch('sb07') === undefined ? 0 : Number(props.watch('sb07'));
    const values4 =
      props.watch('sb08') === undefined ? 0 : Number(props.watch('sb08'));

    const values5 = Number(nine);
    // console.log('밸류5', Number(nine));
    if (values5 === 0) {
      return values1 + values2 + values3 + values4;
    } else {
      return values1 + values2 + values3 + values4 + 1;
    }
  };

  // console.log('기본값', getValues('sb09'));

  return (
    <Fragment>
      <SectionTitle title="STarT背部筛查工具" />
      <Grid item xs={12}>
        <MuiTable columns={columns} rows={rows} />
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: '500',
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  9. 总体来说，过去两周内你的背痛有多烦人？
                </Typography>
                <RadioGroup
                  name={'sb09'}
                  defaultValue={
                    Number(getValues('sb09')) < 5
                      ? Number(getValues('sb09'))
                      : 5
                  }
                >
                  <TableRow
                    sx={{
                      height: '44px',
                      lineHeight: '44px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <Box sx={{ display: 'block' }}>
                      <FormControlLabel
                        sx={{ width: '15.7vw' }}
                        label="完全没有（0分）"
                        control={
                          <Radio
                            disabled={disabled}
                            name={`sb09`}
                            value={0}
                            onChange={handleChange}
                          />
                        }
                      />
                      <FormControlLabel
                        sx={{ width: '15.7vw' }}
                        label="轻微（0分）"
                        control={
                          <Radio
                            disabled={disabled}
                            name={'sb09'}
                            value={1}
                            onChange={handleChange}
                          />
                        }
                      />
                      <FormControlLabel
                        sx={{ width: '15.7vw' }}
                        label="中等（0分）"
                        control={
                          <Radio
                            disabled={disabled}
                            name={'sb09'}
                            value={2}
                            onChange={handleChange}
                          />
                        }
                      />
                      <FormControlLabel
                        sx={{ width: '15.7vw' }}
                        label="非常（1分）"
                        control={
                          <Radio
                            disabled={disabled}
                            name={'sb09'}
                            value={3}
                            onChange={handleChange}
                          />
                        }
                      />
                      <FormControlLabel
                        sx={{ width: '150px', whiteSpace: 'nowrap' }}
                        label="极度（1分）"
                        control={
                          <Radio
                            disabled={disabled}
                            name={'sb09'}
                            value={4}
                            onChange={handleChange}
                          />
                        }
                      />
                    </Box>
                  </TableRow>
                </RadioGroup>
              </TableCell>
              <TableCell>
                <Typography
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  textAlign={'right'}
                ></Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
      <Grid item xs={12}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
          <Typography
            gutterBottom
            minWidth={115}
            fontWeight={700}
            variant="subtitle1"
          >
            总分 : {watchSumValues()}分
            <br />
            子分(Q5~9) :{subSumValues()}分
          </Typography>
          <Typography
            minWidth={115}
            variant="caption"
            sx={{ color: `${palette.primary.main}`, marginTop: ' 40px' }}
          >
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                低风险:
              </Box>
              总分3分或以下
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                中风险:
              </Box>
              总分4分或以上，Q5~Q9分数3分或以下
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                高风险:
              </Box>
              总分4分或以上，Q5~Q9分数4分或以上
            </Typography>
          </Typography>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default STarTContents;
